
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spotlight",
      function () {
        return require("private-next-pages/spotlight/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spotlight"])
      });
    }
  